import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
    MenuItem,
    Button,
    Classes,
    Dialog,
    FormGroup,
    RadioGroup,
    Radio,
    Checkbox,
} from '@blueprintjs/core'

import InputSelect from 'src/components/InputSelect'
import {
    getSelectedActions,
    moveActions,
} from 'src/store/modules/runbooks/actions'
import { singleEditAction } from 'src/store/modules/ui/runbook/controls'

import styles from './moveActionDialog.module.scss'

const SORT = {
    byId: 'by-id',
    alphabetically: 'alphabetically',
}

const BRANCH = {
    continue: 'continue',
    split: 'split',
}

class MoveActionDialog extends React.Component {
    state = {
        actionQuery: '',
        sort: SORT.byId,
        branch: BRANCH.continue,
        sequentialChildren: false,
        selectedAction: null,
    }

    handleSiblingToggle = () => {
        const { prevSibling, parent } = this.state

        this.setState({
            prevSibling: !prevSibling,
            parent: !parent,
        })
    }

    handleSortToggle = () => {
        const { sortAlphabetically } = this.state

        this.setState({
            sortAlphabetically: !sortAlphabetically,
        })
    }

    handleSave = () => {
        const { selectedAction, sort, branch, sequentialChildren } = this.state
        const {
            actions,
            selectedActions,
            singleOpenAction,
            handleClose,
        } = this.props

        let parent = false
        if (branch === BRANCH.split) parent = true

        let sortAlphabetically = false
        if (sort === SORT.alphabetically) sortAlphabetically = true

        actions.moveActions(
            selectedActions.length ? selectedActions : [singleOpenAction],
            {
                to: selectedAction,
                sortAlphabetically: sortAlphabetically,
                parent: parent,
                firstChild:
                    branch === BRANCH.continue ? false : sequentialChildren,
            }
        )
        actions.singleEditAction(null)
        handleClose()
    }

    handleCancel = () => {
        const { actions, handleClose } = this.props

        actions.singleEditAction(null)
        handleClose()
    }

    handleActionSelect = ({ name, uid }) => {
        this.setState({ selectedAction: uid, actionQuery: name })
    }

    handleSortChange = (e) => {
        this.setState({ sort: e.target.value })
    }

    handleBranchChange = (e) => {
        this.setState({ branch: e.target.value })
    }

    handleSequentialChildren = (e) => {
        this.setState({ sequentialChildren: e.target.checked })
    }
    generateActionsItems = () => {
        const { actionQuery } = this.state
        const { runbookActions, singleOpenAction } = this.props

        return runbookActions.uids
            .filter(
                (id) =>
                    (runbookActions.byId[id].name
                        .toLowerCase()
                        .indexOf(actionQuery.toLowerCase()) > -1 ||
                        id.toString().indexOf(actionQuery) > -1) &&
                    id !== singleOpenAction
            )
            .slice(0, 10)
            .map((id) => runbookActions.byId[id])
    }

    actionsItemRenderer = (item, { handleClick, modifiers }) => {
        return (
            <MenuItem
                active={modifiers.active}
                key={item.uid}
                onClick={handleClick}
                text={`${item.uid}. ${item.name}`}
            />
        )
    }

    actionInputValue = (value) => value.name

    render() {
        const {
            actionQuery,
            selectedAction,
            sort,
            branch,
            sequentialChildren,
        } = this.state
        const { handleClose, selectedActions, singleOpenAction } = this.props

        return (
            <Dialog
                onClose={handleClose}
                title="Change relationship"
                isOpen={true}
                canOutsideClickClose={false}
            >
                <div className={Classes.DIALOG_BODY}>
                    <FormGroup label="Action" labelFor="action">
                        <InputSelect
                            inputProps={{
                                id: 'action',
                                placeholder: 'Type an action name',
                                value: actionQuery,
                                large: true,
                            }}
                            popoverProps={{
                                minimal: true,
                            }}
                            minimal
                            fill
                            items={this.generateActionsItems()}
                            itemRenderer={this.actionsItemRenderer}
                            inputValueRenderer={this.actionInputValue}
                            onQueryChange={(value) =>
                                this.setState({ actionQuery: value })
                            }
                            onItemSelect={this.handleActionSelect}
                            noResults={
                                <MenuItem disabled={true} text="No results" />
                            }
                        />
                    </FormGroup>
                    <RadioGroup
                        label="Sort"
                        inline
                        selectedValue={sort}
                        className={styles.sortGroup}
                        onChange={this.handleSortChange}
                    >
                        <Radio large label="By ID" value={SORT.byId} />
                        <Radio
                            large
                            label="Alphabetically"
                            value={SORT.alphabetically}
                        />
                    </RadioGroup>
                    <RadioGroup
                        label="Branch"
                        inline
                        selectedValue={branch}
                        className={styles.branchGroup}
                        onChange={this.handleBranchChange}
                    >
                        <Radio
                            large
                            label={
                                selectedActions.length === 1 || singleOpenAction
                                    ? 'As continue action'
                                    : 'As continue actions'
                            }
                            value={BRANCH.continue}
                        />
                        <Radio
                            large
                            label={
                                selectedActions.length === 1 || singleOpenAction
                                    ? 'As split action'
                                    : 'As split actions'
                            }
                            value={BRANCH.split}
                        />
                    </RadioGroup>

                    {branch === BRANCH.split &&
                    selectedActions.length > 1 &&
                    !singleOpenAction ? (
                        <Checkbox
                            checked={sequentialChildren}
                            label="Sequential children"
                            onChange={this.handleSequentialChildren}
                            className={styles.sequentialChildren}
                        />
                    ) : null}
                </div>

                <div className={Classes.DIALOG_FOOTER}>
                    <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                        <Button
                            intent="primary"
                            disabled={!selectedAction}
                            large
                            onClick={this.handleSave}
                        >
                            Save
                        </Button>
                        <Button
                            intent="lynch-underline"
                            large
                            onClick={this.handleCancel}
                        >
                            Cancel
                        </Button>
                    </div>
                </div>
            </Dialog>
        )
    }
}

const mapMoveActionState = (state, ownProps) => {
    return {
        name: state.ui.runbook.actionsSearch,
        selectedActions: getSelectedActions(state, ownProps.runbookId),
        runbookActions: state.runbooks.byId[ownProps.runbookId].actions,
        singleOpenAction: state.ui.runbook.controls.singleOpenAction,
    }
}

const mapMoveActionDispatch = (dispatch, ownProps) => {
    return {
        dispatch,
        actions: bindActionCreators(
            {
                moveActions: (ids, options) =>
                    moveActions(ownProps.runbookId, ids, options),
                singleEditAction,
            },
            dispatch
        ),
    }
}

export default connect(
    mapMoveActionState,
    mapMoveActionDispatch
)(MoveActionDialog)
